<template>
    <sa-page-layout :btnSaveVisible="true" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <papercleand-articoli-edit-component ref="PapercleandArticoliEditComponent" @update="onUpdateJsonData"></papercleand-articoli-edit-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PapercleandArticoliEditComponent from "../components/PapercleandArticoliEditComponent.vue";
// import PapercleandArticoliEditModalComponent from "../components/PapercleandArticoliEditModalComponent.vue";
// import RsaGestioneOspitiEditComponent from "../components/RsaGestioneOspitiEditComponent.vue";
export default {
    components: { SaPageLayout, PapercleandArticoliEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/articoli",
            linkback: "/papercleanarticoli",
            jsonData: {},
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },

    methods: {
        onUpdateJsonData(data) {
            let me = this;
            // console.log(data);
            me.jsonData = data;
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
        loadData() {
            let me = this;
            me.$refs.PapercleandArticoliEditComponent.init(me.id);
        },
    },
};
</script>

<style></style>
